import { render, staticRenderFns } from "./ChatLoading.vue?vue&type=template&id=5cd509e2&scoped=true"
var script = {}
import style0 from "./ChatLoading.vue?vue&type=style&index=0&id=5cd509e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd509e2",
  null
  
)

export default component.exports